import { useCallback, useEffect, useState } from "react";
import api from "../services/api";

/**
 * Programas de treino (pastas de templates por método) - ver
 * app/api/workout_programs.py. Carrega a lista ao montar e expõe as ações;
 * cada ação recarrega a lista no fim, pra a tela refletir o banco.
 */
export function useWorkoutPrograms({ enabled = true } = {}) {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!enabled) return [];
    setLoading(true);
    try {
      const data = (await api.get("/workout-programs")).data || [];
      setPrograms(data);
      return data;
    } catch (_) {
      setPrograms([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => { reload(); }, [reload]);

  /** Cria ou atualiza o programa e define os treinos, na ordem de planIds. */
  const saveProgram = useCallback(async (programId, { name, method, description }, planIds) => {
    const body = { name, method: method || null, description: description || null };
    const saved = programId
      ? (await api.patch(`/workout-programs/${programId}`, body)).data
      : (await api.post("/workout-programs", body)).data;
    await api.put(`/workout-programs/${saved.id}/plans`, { plan_ids: planIds });
    await reload();
    return saved;
  }, [reload]);

  const deleteProgram = useCallback(async (programId) => {
    await api.delete(`/workout-programs/${programId}`);
    await reload();
  }, [reload]);

  const assignProgram = useCallback(async (programId, { userIds, startDate, daysOfWeek, endCurrent = false }) => {
    return (await api.post(`/workout-programs/${programId}/assign`, {
      user_ids: userIds,
      start_date: startDate || null,
      days_of_week: daysOfWeek,
      end_current: endCurrent,
    })).data;
  }, []);

  const loadHistory = useCallback(async (userId) => {
    return (await api.get(`/workout-programs/history/${userId}`)).data || [];
  }, []);

  return { programs, loading, reload, saveProgram, deleteProgram, assignProgram, loadHistory };
}
